export default {
  NAME_DOSE_NOT_EXIST: "نام وارد نشده است.",
  PERSIAN_NAME_DOSE_NOT_EXIST: "نام فارسی وارد نشده است.",
};
